module.exports = __webpack_public_path__ + "img/reportes.2cc12770.png";